import React from "react";
import { useState, useEffect } from "react";
import "../CSS/header.css";
import { Header } from "./Header";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import franmeetpic from "../Project Images/franmeetpic.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faPhoneAlt,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ClientDetailsModal from "./ClientDetailsModal";

export const ContactUs = () => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Click to Send Details
    </Tooltip>
  );

  const [showComponent, setShowComponent] = useState(false);
  useEffect(() => {
    setShowComponent(true);
  }, []);

  const [showModal, setShowModal] = useState(false);

  // Function to open the modal
  const openClientModal = () => {
    setShowModal(true);
  };

  // Function to close the modal
  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <Header />
      <div
        className={showComponent ? "about-container show" : "about-container"}
      >
        <Card className="text-center">
          <Card.Header style={{ fontSize: "30px", fontWeight: "bold" }}>
            Give Us a Shout
          </Card.Header>
          <Card.Body>
            <Card.Title>Have You Any Project? Please Drop a Message</Card.Title>
            <Card.Text>Get in touch and let us know how we can help</Card.Text>

            <div className="contact-container">
              <div className="contact-left">
                <img src={franmeetpic} alt="Franmeet Pic" />
              </div>
              <div className="contact-right">
                <div className="contact-item">
                  <div className="contact-item-icon">
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                  </div>
                  <div className="contact-item-details">
                    <div className="contact-item-details-line">
                      <h4>Address : </h4>
                      <a>Jakkur - Srirampura, Bangalore</a>
                    </div>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-item-icon">
                    <FontAwesomeIcon icon={faPhoneAlt} />
                  </div>
                  <div className="contact-item-details">
                    <div className="contact-item-details-line">
                      <h4>Phone : </h4>
                      <a>(+91) 8197496775</a>
                    </div>
                  </div>
                </div>
                <div className="contact-item">
                  <div className="contact-item-icon">
                    <FontAwesomeIcon icon={faEnvelope} />
                  </div>
                  <div className="contact-item-details">
                    <div className="contact-item-details-line">
                      <h4>Email : </h4>
                      <a>technomavensgroup@outlook.com</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br />

            <OverlayTrigger
              placement="right"
              delay={{ show: 250, hide: 400 }}
              overlay={renderTooltip}
            >
              <Button onClick={openClientModal} variant="danger" style={{ fontSize: "20px" }}>
                <span style={{ fontFamily: "Arial, Helvetica, sans-serif" }}>
                  Enquire Here
                </span>
              </Button>
            </OverlayTrigger>

            <ClientDetailsModal showModal={showModal} handleClose={handleClose} />
          </Card.Body>
          {/* <Card.Footer className="text-muted">2 days ago</Card.Footer> */}
        </Card>
      </div>
    </>
  );
};
